
// import Breadcrumb from "@/components/Breadcrumb";
import GoodsAccountImg from '@/components/GoodsBoxByMore/goods-account'
import BuyGoodsId from '@/components/GoodsBoxByMore/buy-goods-id'
// import GoodsListPage from "@/components/GoodsListPage";
// const ListLoading = () => import("@/components/ListLoading");
import { mapGetters } from 'vuex'

export default {
    name: 'moreDeals',
    components: {
        // Breadcrumb,
        // GoodsListPage,
        GoodsAccountImg,
        // ListLoading,
        BuyGoodsId
    },
    computed: {
        ...mapGetters({ goodsTypeCateList: 'game/goodsTypeCateList' })
    },
    data() {
        return {
            sortIndex: '',
            search: '',
            num: [],
            sortList: [
                {
                    label: '成交时间',
                    en_name: 'transactionTime'
                },
                {
                    label: '成交价格',
                    en_name: 'price'
                },
                {
                    label: '发布时间',
                    en_name: 'onStandTime'
                }
            ],
            action: {
                gameId: null,
                goodsCatalogueId: null,
                goodsNo: null,
                title: null,
                transactionTime: null
            },
            pageInfo: {
                page: 1,
                pageSize: 10,
                total: 0
            },
            order: null,
            sort: null,
            goodsData: [],
            loading: false
        }
    },
    methods: {
        handleCurrentChange(v) {
            this.pageInfo.page = v
            this.getTransactionPage()
        },
        handleSizeChange(pageSize) {
            this.pageInfo.pageSize = pageSize
            this.pageInfo.page = 1
            this.getTransactionPage()
        },
        goodsTypeHandler(id) {
            this.action.goodsCatalogueId = id
            this.getTransactionPage()
        },
        searchHandler() {
            this.action.title = this.search
            this.getTransactionPage()
        },
        getTransactionPage() {
            this.loading = true
            let p = {}
            if (this.$route.query.gameId) {
                if (this.$route.query.isTop === 'true') {
                    p = {
                        action: {
                            ...this.action,
                            isTop: JSON.parse(this.$route.query.isTop)
                        },
                        order: this.order,
                        sort: this.sort,
                        page: this.pageInfo.page,
                        pageSize: this.pageInfo.pageSize
                    }
                } else {
                    p = {
                        action: { ...this.action },
                        order: this.order,
                        sort: this.sort,
                        page: this.pageInfo.page,
                        pageSize: this.pageInfo.pageSize
                    }
                }
            } else {
                p = {
                    action: { goodsCatalogueId: 6 },
                    order: this.order,
                    sort: this.sort,
                    page: this.pageInfo.page,
                    pageSize: this.pageInfo.pageSize
                }
            }

            this.$api.transactionPage(p).then((res) => {
                this.loading = false
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.goodsData = res.data.records
                this.goodsData.map((item) => {
                    return (item.goodsImg = item.goodsImg && item.goodsImg.replace('?x-oss-process=style/jpg90', '?x-oss-process=style/titleImg'))
                })
                this.pageInfo.total = res.data.total
            })
        },
        sortHandler(en_name, index) {
            let orderType = null
            if (this.num[index] === 0 || this.num[index] === undefined) {
                this.num[index] = 1
                orderType = 'DESC'
                this.sortIndex = index
            } else if (this.num[index] === 1) {
                this.num[index] = 2
                orderType = 'ASC'
                this.sortIndex = index
            } else {
                this.num[index] = 0
                orderType = null
                en_name = null
                this.sortIndex = ''
            }
            this.sort = en_name
            this.order = orderType

            this.getTransactionPage()
        }
    },
    mounted() {
        // 选中第一个

        // if (this.$route.query.time === 'today') {
        // 	this.action.transactionTime = dayjs().subtract(1, 'days').format('YYYY-MM-DD 00:00:00');
        // } else {
        // 	this.action.transactionTime = null;
        // }
        if (this.$route.query.time) {
            this.action.transactionTime = `${this.$route.query.time} 00:00:00`
        }
        if (this.$route.query.gameId) {
            this.action.goodsCatalogueId = parseInt(this.$route.query.goodsCatalogueId || this.goodsTypeCateList[0].id)
            this.action.gameId = this.$route.query.gameId ? parseInt(this.$route.query.gameId) : null
        }
        this.getTransactionPage()
    },
    created() {
        this.$store.dispatch('game/GoodsTypeCateList')
    }
}
